import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import './index.less'
import 'moment/locale/zh-cn'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { install as installModules } from 'services/module'
import registerServiceWorker, { unregister } from 'registerServiceWorker'
import routers from 'modules'
import App from 'App'

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {
    return
  }
  console.debug = () => {
    return
  }
  console.table = () => {
    return
  }
  window.addEventListener('unhandledrejection', err => {
    err.preventDefault()
  })
}
async function main() {
  await installModules(routers)

  ReactDOM.render(
    <App />,

    document.getElementById('root') as HTMLElement
  )
}

main()
// registerServiceWorker()
unregister()



// WEBPACK FOOTER //
// ./src/index.tsx